import { Inject, NgModule } from '@angular/core';
import { GROWTH_BOOK_CONFIG, TGrowthBookConfig } from '@x/common/ab-test/ab-test.config';
import { ABTestService } from '@x/common/ab-test/ab-test.service';

@NgModule({
  providers: [ABTestService],
})
export class AbTestModule {
  constructor(
    @Inject(GROWTH_BOOK_CONFIG)
    private readonly config: TGrowthBookConfig,
    private readonly abTestService: ABTestService,
  ) {
    if (this.config) this.abTestService.init(this.config);
  }
}
